module.exports = __webpack_public_path__ + "img/iphone-x.be482886.png";